/**
 * @generated SignedSource<<c7d0548898f06ce589e9656765834d9e>>
 * @relayHash a1ee15cc9106802e3f7437a4f49138f7
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 0e0f01a1e0cffc5fc6577a9126fdf6e723e5ab166cb870430c91072fd5f08078

import type { ConcreteRequest } from 'relay-runtime';
export type ConfluencePricingEndOfTrialPremiumToStandardQuery$variables = {
  cloudId: string;
  productKey: string;
};
export type ConfluencePricingEndOfTrialPremiumToStandardQuery$data = {
  readonly tenantContexts: ReadonlyArray<{
    readonly entitlementInfo: {
      readonly entitlement: {
        readonly experienceCapabilities?: {
          readonly changeOfferingV2: {
            readonly experienceUrl: string | null | undefined;
            readonly isAvailableToUser: boolean | null | undefined;
          } | null | undefined;
        } | null | undefined;
        readonly standardPrice?: ReadonlyArray<{
          readonly listPriceForOrderWithDefaults: ReadonlyArray<{
            readonly averageAmountPerUnit: number | null | undefined;
            readonly item: {
              readonly chargeElement: string | null | undefined;
            } | null | undefined;
          } | null | undefined> | null | undefined;
        } | null | undefined> | null | undefined;
        readonly subscription?: {
          readonly trial: {
            readonly listPriceEstimates: ReadonlyArray<{
              readonly averageAmountPerUnit: number | null | undefined;
              readonly item: {
                readonly chargeElement: string | null | undefined;
              } | null | undefined;
            } | null | undefined> | null | undefined;
          } | null | undefined;
        } | null | undefined;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined> | null | undefined;
};
export type ConfluencePricingEndOfTrialPremiumToStandardQuery = {
  response: ConfluencePricingEndOfTrialPremiumToStandardQuery$data;
  variables: ConfluencePricingEndOfTrialPremiumToStandardQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "productKey"
  }
],
v1 = [
  {
    "items": [
      {
        "kind": "Variable",
        "name": "cloudIds.0",
        "variableName": "cloudId"
      }
    ],
    "kind": "ListValue",
    "name": "cloudIds"
  }
],
v2 = [
  {
    "kind": "Variable",
    "name": "hamsProductKey",
    "variableName": "productKey"
  }
],
v3 = {
  "concreteType": "CcpEntitlementExperienceCapabilities",
  "kind": "LinkedField",
  "name": "experienceCapabilities",
  "plural": false,
  "selections": [
    {
      "args": [
        {
          "kind": "Literal",
          "name": "offeringName",
          "value": "standard"
        },
        {
          "kind": "Literal",
          "name": "skipTrial",
          "value": true
        }
      ],
      "concreteType": "CcpChangeOfferingExperienceCapability",
      "kind": "LinkedField",
      "name": "changeOfferingV2",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "isAvailableToUser"
        },
        {
          "kind": "ScalarField",
          "name": "experienceUrl"
        }
      ],
      "storageKey": "changeOfferingV2(offeringName:\"standard\",skipTrial:true)"
    }
  ]
},
v4 = [
  {
    "kind": "Literal",
    "name": "offeringName",
    "value": "Standard"
  }
],
v5 = [
  {
    "kind": "ScalarField",
    "name": "averageAmountPerUnit"
  },
  {
    "concreteType": "CcpPricingPlanItem",
    "kind": "LinkedField",
    "name": "item",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "chargeElement"
      }
    ]
  }
],
v6 = {
  "concreteType": "CcpListPriceEstimate",
  "kind": "LinkedField",
  "name": "listPriceForOrderWithDefaults",
  "plural": true,
  "selections": (v5/*: any*/)
},
v7 = {
  "concreteType": "CcpTrial",
  "kind": "LinkedField",
  "name": "trial",
  "plural": false,
  "selections": [
    {
      "concreteType": "CcpListPriceEstimate",
      "kind": "LinkedField",
      "name": "listPriceEstimates",
      "plural": true,
      "selections": (v5/*: any*/)
    }
  ]
},
v8 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v9 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "ConfluencePricingEndOfTrialPremiumToStandardQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "TenantContext",
        "kind": "LinkedField",
        "name": "tenantContexts",
        "plural": true,
        "selections": [
          {
            "args": (v2/*: any*/),
            "kind": "LinkedField",
            "name": "entitlementInfo",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "name": "entitlement",
                "plural": false,
                "selections": [
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v3/*: any*/),
                      {
                        "alias": "standardPrice",
                        "args": (v4/*: any*/),
                        "concreteType": "CcpEntitlementOfferingTransition",
                        "kind": "LinkedField",
                        "name": "defaultOfferingTransitions",
                        "plural": true,
                        "selections": [
                          (v6/*: any*/)
                        ],
                        "storageKey": "defaultOfferingTransitions(offeringName:\"Standard\")"
                      },
                      {
                        "concreteType": "CcpSubscription",
                        "kind": "LinkedField",
                        "name": "subscription",
                        "plural": false,
                        "selections": [
                          (v7/*: any*/)
                        ]
                      }
                    ],
                    "type": "CcpEntitlement"
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ConfluencePricingEndOfTrialPremiumToStandardQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "TenantContext",
        "kind": "LinkedField",
        "name": "tenantContexts",
        "plural": true,
        "selections": [
          {
            "args": (v2/*: any*/),
            "kind": "LinkedField",
            "name": "entitlementInfo",
            "plural": false,
            "selections": [
              (v8/*: any*/),
              {
                "kind": "LinkedField",
                "name": "entitlement",
                "plural": false,
                "selections": [
                  (v8/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v3/*: any*/),
                      {
                        "alias": "standardPrice",
                        "args": (v4/*: any*/),
                        "concreteType": "CcpEntitlementOfferingTransition",
                        "kind": "LinkedField",
                        "name": "defaultOfferingTransitions",
                        "plural": true,
                        "selections": [
                          (v6/*: any*/),
                          (v9/*: any*/)
                        ],
                        "storageKey": "defaultOfferingTransitions(offeringName:\"Standard\")"
                      },
                      {
                        "concreteType": "CcpSubscription",
                        "kind": "LinkedField",
                        "name": "subscription",
                        "plural": false,
                        "selections": [
                          (v7/*: any*/),
                          (v9/*: any*/)
                        ]
                      }
                    ],
                    "type": "CcpEntitlement"
                  },
                  (v9/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "a1ee15cc9106802e3f7437a4f49138f7",
    "id": "0e0f01a1e0cffc5fc6577a9126fdf6e723e5ab166cb870430c91072fd5f08078",
    "metadata": {},
    "name": "ConfluencePricingEndOfTrialPremiumToStandardQuery",
    "operationKind": "query",
    "text": "query ConfluencePricingEndOfTrialPremiumToStandardQuery($cloudId:ID!,$productKey:String!){tenantContexts(cloudIds:[$cloudId]){entitlementInfo(hamsProductKey:$productKey){__typename,entitlement{__typename,...on CcpEntitlement{experienceCapabilities{changeOfferingV2(skipTrial:true,offeringName:\"standard\"){isAvailableToUser,experienceUrl}},standardPrice:defaultOfferingTransitions(offeringName:\"Standard\"){listPriceForOrderWithDefaults{averageAmountPerUnit,item{chargeElement}},id},subscription{trial{listPriceEstimates{averageAmountPerUnit,item{chargeElement}}},id}},id}}}}"
  }
};
})();

(node as any).hash = "689ba1aea16ebc0b8b7c30d1915df2c7";

export default node;
